import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type PainPoint = {
  number: string;
  title: string;
  description: string;
  tone?: 'gold' | 'burgundy';
};
const PAIN_POINTS: PainPoint[] = [{
  number: '01',
  title: 'No sabés por dónde empezar',
  description: 'Te cuesta definir cómo iniciar cada encuentro.'
}, {
  number: '02',
  title: 'Sentís que improvisás',
  description: 'No tenés recursos organizados para cada momento.'
}, {
  number: '03',
  title: 'Te cuesta llegar a la raíz',
  description: 'Necesitás preguntas para explorar las dinámicas familiares.'
}, {
  number: '04',
  title: 'No sabés cómo continuar',
  description: 'Te faltan fichas y recursos para el seguimiento.'
}, {
  number: '05',
  title: '¿Y si tu consultante te pregunta algo que no sabés cómo abordar?',
  description: 'Aparece una situación inesperada y sentís que te faltan preguntas o recursos para continuar con claridad.',
  tone: 'burgundy'
}, {
  number: '06',
  title: '¿Y si tu consultante vuelve y no tenés claro qué trabajaron?',
  description: 'Sin fichas ni seguimiento organizado, reconstruir lo ocurrido y preparar el próximo encuentro puede volverse difícil.',
  tone: 'burgundy'
}];
export function PainPoints() {
  const prefersReducedMotion = useReducedMotion();
  return <section className="w-full bg-[#fdfbf7] py-14 md:py-20" data-id="element-228" data-mp="1g1szlj9z3l41">
      <div className="mx-auto max-w-3xl px-4" data-id="element-229" data-mp="1g2cfyvjz61fy">
        <motion.header initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 14
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-xl text-center" data-id="element-230" data-mp="1b2zlbomv3q2t">
          <p className="text-[10px] font-black uppercase tracking-[0.22em] text-[#a8894f] md:text-xs" data-id="element-231" data-mp="30ftb874j97un">
            ¿Te pasa esto en tus sesiones?
          </p>
          <h2 className="mt-3 font-['Playfair_Display',_serif] text-3xl font-bold leading-tight text-[#2e1065] md:text-5xl" data-id="element-232" data-mp="1t5y8ik5tod2h">
            Tu experiencia merece una estructura que te acompañe.
          </h2>
          <p className="mx-auto mt-3 max-w-[37ch] text-sm leading-relaxed text-[#665873] md:text-base" data-id="element-233" data-mp="226wf9a7nayor">
            No siempre faltan conocimientos. A veces faltan herramientas para
            ordenar el proceso.
          </p>
        </motion.header>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={prefersReducedMotion ? undefined : {
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.07
          }
        }
      }} className="mt-8 grid grid-cols-2 gap-3 md:gap-4" data-id="element-234" data-mp="1acudaucyhs5r">
          {PAIN_POINTS.map(point => <motion.article key={point.number} variants={prefersReducedMotion ? undefined : {
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex min-h-[160px] flex-col rounded-2xl border bg-[#fffdf8] p-4 md:min-h-[174px] md:p-5 ${point.tone === 'burgundy' ? 'border-[#c8a0a0]' : 'border-[#dfc994]'}`} data-id="element-235" data-mp="vo6m10a584lm">
              <span className={`inline-flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-black tracking-wide text-white ${point.tone === 'burgundy' ? 'bg-[#8f3c45]' : 'bg-[#b78b31]'}`} data-id="element-236" data-mp="3rmfixa1rh4uv">
                {point.number}
              </span>
              <h3 className="mt-4 text-[15px] font-extrabold leading-snug text-[#2e1065] md:text-lg" data-id="element-237" data-mp="3doijm5vxakci">
                {point.title}
              </h3>
              <p className="mt-2 text-[12px] leading-relaxed text-[#665873] md:text-sm" data-id="element-238" data-mp="1llmuextkp4zi">
                {point.description}
              </p>
            </motion.article>)}
        </motion.div>

        <motion.p initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 12
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.35,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-[38ch] text-center font-['Playfair_Display',_serif] text-lg leading-snug text-[#51405f] md:text-xl" data-id="element-239" data-mp="1ct2tfqpt6obi">
          Tu consultante merece un{' '}
          <strong className="font-bold text-[#2e1065]" data-id="element-240" data-mp="2j9et5w8a4e97">espacio preparado</strong>.
          Y vos merecés{' '}
          <strong className="font-bold text-[#2e1065]" data-id="element-241" data-mp="2o881794srd1z">
            herramientas que te den seguridad
          </strong>{' '}
          para acompañarlo.
        </motion.p>
      </div>
    </section>;
}